/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MappingReviewRequest = {
  /**
   * MappingReference ids to settle in one batch.
   */
  mapping_ids: Array<number>;
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept); reopen => back to 'pending'.
   */
  action: MappingReviewRequest.action;
};
export namespace MappingReviewRequest {
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept); reopen => back to 'pending'.
   */
  export enum action {
    ACCEPT = 'accept',
    DISMISS = 'dismiss',
    REOPEN = 'reopen',
  }
}

